import isoCountries from 'i18n-iso-countries';
import en from "i18n-iso-countries/langs/en.json";
import de from "i18n-iso-countries/langs/de.json";

isoCountries.registerLocale(en);
isoCountries.registerLocale(de);

export default isoCountries;
